export const en = {
  claimMyBonus: 'Claim My Bonus Now',
  copyright: 'Copyright © 2025. Tauro Markets. All Rights Reserved.',
  depositMinimum: 'Deposit a minimum of $200 into your Classic MT5 account',
  downloadMt5: 'Download MT5 Platform',
  enjoyTight:
    'Enjoy tight spreads that give you more value on every trade, across major forex pairs and metals.',
  forComplaints: 'For complaints please email us at',
  fsc: 'Financial Services Commission (FSC) ',
  fullyLicensed:
    'Tauro Markets is a fully licensed and regulated broker under the Financial Services Commission (FSC) of Mauritius.',
  get50Bonus: 'Get a 50% Bonus Instantly',
  here: 'here',
  heroBlackHeader: 'Double Your Edge with a',
  heroRedHeader: '50% Deposit Bonus',
  heroSubheader: 'Start trading with extra firepower on MT5. Deposit $200+ and get',
  heroSubheaderBold: 'up to $750 bonus',
  langName: 'English',
  mauritius: 'Mauritius',
  mt5: 'MT5 Platform with advanced tools',
  multilingualSupport: '24/5 multilingual support',
  okay: 'Okay',
  ourGlobalSupportTeam:
    'Our global support team is available 24/5 to assist you in your language. Quick, clear, and professional.',
  pleaseReview: 'Please review the company policies and legal documents',
  receive50Deposit: 'Receive 50% of your deposit, up to a maximum of $750, credited as bonus funds',
  registerAndClaim: 'Register and Claim My Bonus Now',
  registerAndFund: 'Register & Fund Your Account',
  registerToday:
    'Register today to trade the financial markets with world class products and services.',
  regulatedBy: 'Regulated by the FSC',
  regulatedByFooter: 'Regulated by the',
  riskHead1: 'Risk Warning',
  riskHead2: 'Legal Information',
  riskHead3: 'Restricted Jurisdictions',
  riskPara1:
    'Leveraged trading in foreign currency contracts, contracts for difference or other off-exchange products carries a high level of risk and may not be suitable for everyone. Before trading, you are strongly advised to read and ensure that you understand the relevant risk disclosures. There is a substantial risk that you may lose all of your initial investment. We advise you to consider whether trading leveraged products is appropriate for you in light of your own personal circumstances. We recommend that you seek independent financial advice and ensure that you fully understand all risks involved before trading.',
  riskPara2:
    'Tauro Markets is a brand registered in Mauritius by Inno Net Solutions. The website is owned by Inno Net Solutions (Company Registration: 208180, which is authorised, licensed and regulated by the Financial Services Commission bearing license No. GB24202909). Registered Office Address: Rue de la Democratie CO AllServ Management Ltd Office 306 3rd Floor Ebene Junction Ebene 72201MAURITIUS and Physical Address: Office Number 101, Palm Court Offices, 1st Floor, 90 St Jean Road, Quatre Brones, Mauritius',
  riskPara3:
    'We do not establish accounts to residents of certain jurisdictions including Belgium, Democratic Republic of Congo, Eritrea, Iran, Democratic People’s Republic of Korea, Libyan Arab Jamahiriya, Somalia, Sudan, Israel, Mauritius, United States (and US reportable persons) or any particular country or jurisdiction where such distribution or use would be contrary to local law or regulation.',
  spreads: 'Competitive spreads',
  startTrading: 'Start Trading & Withdraw',
  stepsHeader: 'Claim Your Bonus in',
  stepsHeaderRed: '3 Simple Steps',
  tauroMarkets: 'Tauro Markets',
  tcHead1: '1. Eligibility',
  tcHead2: '2. Claiming the Deposit Bonus',
  tcHead3: '3. Trading Volume Requirements',
  tcHead4: '4. Withdrawal Conditions',
  tcHead5: '5. Additional Terms',
  tcMainHeader: 'General Deposit Bonus Terms & Conditions',
  tcMainIntro:
    'These Terms and Conditions apply to the Deposit Bonus promotion offered by Tauro Markets and are available to clients in a limited number of countries. Clients are advised to consult with Customer Support for details regarding specific campaigns and availability.',
  tcPara11:
    '1.1. The Deposit Bonus offer is exclusively available for clients trading on the MetaTrader 5 (MT5) platform and is only applicable to Classic Accounts.',
  tcPara12:
    '1.2. This promotion is open to both new and existing clients of Tauro Markets (regulated by the Financial Services Commission) who maintain an active Live Trading Account.',
  tcPara13:
    '1.3. To participate, clients must make a qualifying deposit into their Live Trading Account.',
  tcPara14:
    '1.4. The one-time Deposit Bonus offered is 50% of the deposited amount, with a maximum reward of $750 per Client.',
  tcPara21:
    '2.1. The minimum deposit required to claim the Deposit Bonus is $200 (internal transfers are not accounted).',
  tcPara31:
    '3.1. To withdraw or transfer the Deposit Bonus, clients must complete a trading volume of at least 2.5 standard lots per every $5 of the Deposit Bonus received.',
  tcPara32:
    '3.2. Until the required trading volume is met, the client’s account balance and available margin must remain equal to or greater than the combined total of the original deposit and the Deposit Bonus to be eligible for withdrawal of trading profits.',
  tcPara33:
    '3.3. Only trading volume from currency pairs and metals contributes towards the required trading volume calculation. CFDs, Indices, USOIL, and Cryptocurrencies are excluded from this calculation.',
  tcPara41:
    '4.1. Any portion of the Deposit Bonus may only be withdrawn if the client has met the total trading volume requirement for the full bonus amount received, as specified in Section 3.1.',
  tcPara42:
    '4.2. Clients who fail to meet the trading volume requirement but wish to withdraw their own deposited funds must ensure that their account balance and margin requirements remain sufficient, as stated in Section 3.2.',
  tcPara51:
    '5.1. Tauro Markets reserves the right to modify, suspend, or terminate the Deposit Bonus at any time without prior notice.',
  tcPara52:
    '5.2. In cases of suspected abuse, fraud, or violation of the bonus terms, Tauro Markets retains the right to cancel the bonus and any associated trading profits.',
  tcPara53:
    '5.3. By participating in this promotion, clients agree to all terms and conditions stated herein, as well as Tauro Markets’ general Terms of Service and Trading Conditions.',
  tcFinal: 'For any clarifications or inquiries, please contact our Customer Support.',
  tradeSmarter:
    'Trade smarter with MT5, our powerful, intuitive platform optimized for all your devices.',
  trade25:
    'Trade 2.5 standard lots for every $5 of bonus to unlock it. Valid for forex and metals.',
  warning: 'Tauro Markets is a multi-asset investment platform. The value of your investments may go up or down. Your capital is at risk.',
  whyChoose: 'Why Choose',
}
